import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const AuthedUser = () => {
	const navigate = useNavigate();

	const handleGoToHome = () => {
		navigate("/home");
	};

	const handleLogout = () => {
		navigate("/logout");
	};

	const AuthPageStyles = {
		backgroundImage: `url('/home_bg2.jpg')`,
		backgroundSize: "cover",
		backgroundPosition: "center",
	};

	return (
		<Box className="login-container" sx={AuthPageStyles}>
			<Box className="login-form-container">
				<img src="/logo.png" alt="Logo" className="login-logo" />
				<Box className="authenticated-container">
					<Typography variant="h6" gutterBottom>
						You are already logged in!
					</Typography>
					<Box display="flex" justifyContent="center" gap={2} mt={2}>
						<Button variant="contained" color="primary" onClick={handleGoToHome}>
							Go to Home
						</Button>
						<Button variant="outlined" color="primary" onClick={handleLogout}>
							Logout
						</Button>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default AuthedUser;
